import { computed, ref, watch } from 'vue'
import { request } from '../utils.js'
import useLoading from './loading.js'

export default function useBuildingsPeople() {
  const { isLoading, start, stop } = useLoading()

  const s = ref(null)
  const buildings = ref(null)

  async function fetchBuildingsPeople(term) {
    start('buildings-people')
    buildings.value = await request(`/buildings/people?s=${term}`)
    stop('buildings-people')
  }

  watch(() => s.value, value => fetchBuildingsPeople(value))

  return {
    s,
    buildings,
    buildingsPeopleIsLoading: computed(() => isLoading('buildings-people')),
  }
}
